import axiosInstance from "../../../helpers/api";
import { FIXED_GEMINI_FLASH } from "./grader-models";

export const getMarkSchemesBySubject = () => {
  return axiosInstance.get("/admin/mark_schemes/subject");
};

export const createMarkScheme = (formData) => {
  return axiosInstance.post("/admin/mark_schemes", formData);
};

export const registerMarkScheme = (body) => {
  return axiosInstance.post("/admin/mark_schemes/register", {
    ...body,
    ocr_model: body?.ocr_model || FIXED_GEMINI_FLASH,
    grading_model: body?.grading_model || FIXED_GEMINI_FLASH,
  });
};

/**
 * Proxy through Laravel to avoid browser CORS against grader.edutopiaonline.com.
 * Backend should forward to POST https://grader.edutopiaonline.com/api/papers/mark
 */
export const markPaperWithAi = (body) => {
  return axiosInstance.post("/admin/mark_schemes/mark_paper", body);
};
